import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useStore from '../store';

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const fetchSubscription = useStore((s) => s.fetchSubscription);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    // The checkout.session.completed webhook is asynchronous, so a single fetch
    // can still read "free". Re-poll on each countdown tick until it lands.
    fetchSubscription();

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/', { replace: true });
          return 0;
        }
        fetchSubscription();
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [fetchSubscription, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="text-center max-w-sm">
        <div className="text-6xl mb-4 animate-bounce">🎉</div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Welcome to Premium!
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mb-6">
          You now have access to unlimited habits, streak freezes, advanced analytics, and more.
        </p>
        <p className="text-sm text-gray-400 dark:text-gray-500">
          Redirecting to dashboard in {countdown}...
        </p>
      </div>
    </div>
  );
}
